<template>
  <div :class="$style.container">
    <div :class="$style.title" v-html="title" />
    <video ref="videoPlayer" class="video-js vjs-fluid" />
  </div>
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

export default {
  name:  "VideoPlayer",
  props: {
    title:   {},
    options: {},
  },
  data() {
    return {
      player: null,
    };
  },
  mounted() {
    const { videoPlayer } = this.$refs;
    this.player = videojs(this.$refs.videoPlayer, this.options);

    if (videoPlayer.addEventListener) {
      videoPlayer.addEventListener('contextmenu', function ( e ) {
        e.preventDefault();
      }, false);
    } else {
      videoPlayer.attachEvent('oncontextmenu', function () {
        window.event.returnValue = false;
      });
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>

<style lang="scss" module>
.container {
  flex: 0 1 50%;
  padding: 15px;

  @media screen and (max-width: 980px) {
    flex: 0 1 100%;
  }

  :global {
    .video-js .vjs-big-play-button {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

.title {
  line-height: 1.2;
  text-align: center;
  margin-bottom: 15px;
  font-size: 1.5rem;
  font-weight: 500;
  color: rgba(var(--app-heading-color), 1);
}

</style>
